<template>
  <span v-if="hasPermission()">
    <slot></slot>
  </span>
</template>

<script>

export default {
  props: {
    name: [String, Array]
  },
  methods: {
    hasPermission() {
      let user = this.$store.state.user
      if (!user) {
        return false;
      }

      if (typeof this.name === 'string') {
        return user.permissions.includes(this.name.trim());
      }

      return this.name.map(permission => permission.trim())
        .filter(permission => user.permissions.includes(permission)).length > 0;
    }
  }
}
</script>
